export const HowToMakeSongChapters = [
  {
    title: 'Chapter 1: Free Tool for Generating Song Ideas',
    description:
      'Start with an idea. Learn how to quickly find great song ideas and prompts to get your inspiration flowing with ChordChord’s Free Interactive Tool.',
    img: 'chapter-1.png',
    link: '/song-ideas-generator-tool',
  },
  {
    title: 'Chapter 2: 8 Most Common Chord Progressions to Jumpstart Your Song',
    description: 'Pick a common chord progression that reflects your emotion and idea.',
    img: 'chapter-2.png',
    link: '/8-most-common-chord-progressions',
  },
  {
    title: 'Chapter 3: How to Write Song Lyrics',
    description: 'Find out how to write song lyrics that will engage the audience.',
    img: 'chapter-3.png',
    link: '/how-to-write-song-lyrics',
  },
  {
    title: 'Chapter 4: How to Write A Melody For Your Song',
    description:
      "Learn to write melodies that capture the listener's attention and create an emotional connection with the audience.",
    img: 'chapter-4.png',
    link: '/how-to-write-a-melody',
  },
  {
    title: 'Chapter 5: Breaking Down the Beat: Most Popular Rhythms in Music Making',
    description: 'Study how different rhythms create tension, movement, and add variety to the melody.',
    img: 'chapter-5.png',
    link: '/most-popular-rhythms-in-music-making',
  },
  {
    title: 'Chapter 6: Free Song Structure Template Generator',
    description: 'Structure your song in a way that the listener doesn’t get bored and stays engaged.',
    img: 'chapter-6.png',
    link: '/song-structure-template-generator-tool',
  },
  {
    title: 'Chapter 7: Home Recording Equipment Every Songwriter Needs',
    description:
      'Find the essential list of studio equipment that you’ll absolutely need along your songwriting journey.',
    img: 'chapter-7.png',
    link: '/home-recording-equipment-for-music-makers',
  },
]
